export const environment = {
    "aws": {
        "Auth": {
            "authenticationFlowType": "USER_PASSWORD_AUTH",
            "cookieStorage": {
                "domain": ".examsoft.io",
                "expires": 365,
                "path": "/",
                "secure": true
            },
            "identityPoolId": "us-west-2:2c8cd130-d4b5-4308-9810-d0cc196aa196",
            "identityPoolRegion": "us-west-2",
            "region": "us-west-2",
            "userPoolId": "us-west-2_cROlf0oJL",
            "userPoolWebClientId": "44smfvm0841fcjb1idd5vl3f34"
        },
        "oauth": {
            "domain": "cog004usorprod.auth.us-west-2.amazoncognito.com",
            "options": {
                "AdvancedSecurityDataCollectionFlag": true
            },
            "redirectSignIn": "window.location.origin",
            "redirectSignOut": "window.location.origin",
            "responseType": "code",
            "scope": [
                "phone",
                "email",
                "profile",
                "openid",
                "aws.cognito.signin.user.admin"
            ]
        }
    },
    "esLogin": "https://login.examsoft.com/",
    "launchDarklySecretKey": "62eace1e82670e11054c6474",
    "macDownloadUrl": "https://releases.examsoft.com/Examplify/Examplify_LATEST_mac.dmg",
    "metadata": {
        "application_code": "phx",
        "geographic_code": "us",
        "instance_index": "004"
    },
    "phxLogoutUrl": "https://ui.examsoft.io/logout",
    "phxUrl": "https://ui.examsoft.io",
    "production": true,
    "urls": {
        "institutionApiUrl": "https://cog004-api-prod.examsoft.com/institutions",
        "marsAssessmentUrl": "https://mrs004-api-v2-prod.examsoft.com",
        "marsAssessmentUrlV2": "https://mrs004-api-v2-prod.examsoft.com",
        "marsSOReportUrl": "https://mrs004-api-v2-prod.examsoft.com",
        "marsSOReportUrlV2": "https://mrs004-api-v2-prod.examsoft.com",
        "paypalAPIUrl": "https://www.paypal.com/sdk/js?client-id=AcQgSLsCwV9o5VNzgvQoff3SUhcKkkTnF3sf3q-wFmhTTAvqQlMNxWMliip9Pz9sk2P5XRzSsQIWGv0u&disable-funding=credit,card",
        "studentPortalAPIUrl": "https://prod-api.examsoft.io"
    },
    "winDownloadUrl": "https://releases.examsoft.com/Examplify/Examplify_LATEST_win.exe"
};